import Acao from 'model/administracao/cadastro/Acao';
import MenuOpcao from 'model/menu/MenuOpcao';
import { createContext } from 'react';

interface AuthContextData {
    listaOpcoes: MenuOpcao[];
    acoes: Acao[];
    estaLogado: boolean;
    nomeUsuario: string;
    nomeConta: string;
    nomeSetor: string;
    login(estado: AuthContextData): void;
}
const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export default AuthContext;
